var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSevenSegment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "192px",
    height: "320px",
    viewBox: "-1 -1 12 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "abcdefg",
    style: {
      fillRule: "evenodd",
      stroke: "#FFFFFF",
      strokeWidth: 0.25,
      strokeOpacity: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "a",
    points: " 1, 1  2, 0  8, 0  9, 1  8, 2  2, 2",
    fill: "#FF0000"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "b",
    points: " 9, 1 10, 2 10, 8  9, 9  8, 8  8, 2",
    fill: "#FF0000"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "c",
    points: " 9, 9 10,10 10,16  9,17  8,16  8,10",
    fill: "#FF0000"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "d",
    points: " 9,17  8,18  2,18  1,17  2,16  8,16",
    fill: "#FF0000"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "e",
    points: " 1,17  0,16  0,10  1, 9  2,10  2,16",
    fill: "#FF0000"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "f",
    points: " 1, 9  0, 8  0, 2  1, 1  2, 2  2, 8",
    fill: "#FF0000"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "g",
    points: " 1, 9  2, 8  8, 8  9, 9  8,10  2,10",
    fill: "#FF0000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSevenSegment);
export default __webpack_public_path__ + "static/media/seven-segment.7805e2967e3a55981a3e785053b212d0.svg";
export { ForwardRef as ReactComponent };